export default "__VITE_ASSET__DeqQxIrL__"